import { render } from "./DatosBanco.vue?vue&type=template&id=0baeb5f5&scoped=true"
import script from "./DatosBanco.vue?vue&type=script&lang=js"
export * from "./DatosBanco.vue?vue&type=script&lang=js"

import "./DatosBanco.vue?vue&type=style&index=0&id=0baeb5f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baeb5f5"]])

export default __exports__